import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { RouterProvider } from "react-router-dom";
import { router } from "routes";
//redux
import { Provider } from "react-redux";

import { PrimeReactProvider } from "primereact/api";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import "primeicons/primeicons.css";

// import "primereact/resources/primereact.css";
import "primereact/resources/primereact.min.css";
// import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";

//toast
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

//dayjs
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import store from "store/store";
import { Toaster } from "sonner";
import { ErrorBoundary } from "react-error-boundary";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
      staleTime: 0,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
const value = {
  ripple: false,
};
// Extend dayjs with UTC plugin
dayjs.extend(utc);

root.render(
  <>
    <QueryClientProvider client={queryClient}>
      <Toaster richColors position="bottom-right" />
      <Provider store={store}>
        <PrimeReactProvider value={value}>
          <ToastContainer
            autoClose={2000}
            position="top-center"
            hideProgressBar
          />
          <ErrorBoundary fallback={<div> Something went wrong </div>}>
            <RouterProvider router={router} />
          </ErrorBoundary>
        </PrimeReactProvider>
      </Provider>
    </QueryClientProvider>
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals)
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
